export const primary = "#00008B";
export const background = "#ADD8E6";
